/**
 * Commissions / Promos Zod schemas (m06).
 */

import { z } from 'zod';
import { IsoTsSchema, PaginationQuerySchema } from './common';

export const PromoKindSchema = z.enum(['FLAT_BONUS', 'PCT_BUMP', 'CAPPED']);
export const PromoAppliesToSchema = z.enum(['ALL', 'DEALER', 'DISTRIBUTOR', 'HIERARCHY_EDGE']);
export const PromoStatusSchema = z.enum(['ACTIVE', 'PAUSED', 'ARCHIVED']);

export const FlatBonusValueSchema = z.object({ amount: z.number().positive() });
export const PctBumpValueSchema = z.object({ bumpPct: z.number().positive().max(100) });
export const CappedValueSchema = z.object({
  bumpPct: z.number().positive().max(100),
  maxAmount: z.number().positive(),
});

export const PromoValueSchema = z.union([
  FlatBonusValueSchema,
  PctBumpValueSchema,
  CappedValueSchema,
]);

export const CreatePromoInputSchema = z.object({
  name: z.string().min(1).max(200),
  kind: PromoKindSchema,
  value: PromoValueSchema,
  appliesTo: PromoAppliesToSchema,
  filter: z.record(z.string(), z.unknown()).optional(),
  startsAt: IsoTsSchema,
  endsAt: IsoTsSchema,
});

export const UpdatePromoInputSchema = CreatePromoInputSchema.partial().extend({
  status: PromoStatusSchema.optional(),
});

export const ListPromosQuerySchema = PaginationQuerySchema.extend({
  status: PromoStatusSchema.optional(),
  activeAt: IsoTsSchema.optional(),
});

export const SetCommissionInputSchema = z.object({
  commissionPercentage: z.number().min(0).max(100),
});

export const EarningsQuerySchema = PaginationQuerySchema.extend({
  from: IsoTsSchema.optional(),
  to: IsoTsSchema.optional(),
  status: z.enum(['EARNED', 'PAID', 'REVERSED']).optional(),
});

export type CreatePromoInput = z.infer<typeof CreatePromoInputSchema>;
export type UpdatePromoInput = z.infer<typeof UpdatePromoInputSchema>;
export type SetCommissionInput = z.infer<typeof SetCommissionInputSchema>;
